// extracted by mini-css-extract-plugin
export default {"desktopPageTitle":"desktopPageTitle__Y2JkZ","mobilePageTitle":"mobilePageTitle__MDM1O","clickable":"clickable__OWNiO","noWrap":"noWrap__MDQxN","editLocation":"editLocation__MzdmO"};